import {Module} from 'react-360-web';

export default class NativeXHRModule extends Module {
    static eventTypes = ['abort', 'error', 'load', 'loadend', 'loadstart', 'progress', 'timeout'];

    constructor() {
        super('NativeXHRModule');
        this.ctx = null;
        this.requests = [];
    }

    setContext(reactNativeContext) {
        this.ctx = reactNativeContext;
    }

    /**
     * Create an XHR request and return an id for use in referencing
     * that request with this module.
     * @returns {number}
     */
    $createRequest(resolveId, rejectId) {
        const request = new window.XMLHttpRequest();
        this.requests.push(request);
        const requestId = this.requests.length - 1;
        NativeXHRModule.eventTypes.forEach((eventType) => {
            request.addEventListener(eventType, (event) => {
                this.ctx.callFunction('RCTDeviceEventEmitter', 'emit', [
                    `NativeXHR.${eventType}.${requestId}`,
                    event
                ]);
            });
        });
        this.ctx.invokeCallback(resolveId, [requestId]);
    }

    /**
     * Remove the request referenced by id.
     * @param id
     */
    $releaseRequest(id, resolveId, rejectId) {
        this.requests[id] = null;
        this.ctx.invokeCallback(resolveId, []);
    }

    $setProperties(id, newProperties: Object, resolveId, rejectId) {
        const request = this.requests[id];
        for (const [key, value] of Object.entries(newProperties)) {
            request[key] = value;
        }
        this.ctx.invokeCallback(resolveId, [newProperties]);
    }

    $getProperties(id, properties: Array<String>, resolveId, rejectId) {
        const lookup = {};
        const request = this.requests[id];
        const ctx = this.ctx;
        properties.forEach((key) => {
            lookup[key] = request[key];
        });
        if (lookup.response && request.responseType === 'blob') {
            let fileReader = new FileReader();
            fileReader.onload = function(event) {
                lookup.response = event.target.result;
                ctx.invokeCallback(resolveId, [lookup]);
            };
            fileReader.readAsDataURL(lookup.response);
        } else {
            ctx.invokeCallback(resolveId, [lookup]);
        }
    }

    $open(id, method, url, user, password, resolveId, rejectId) {
        const request = this.requests[id];
        request.open(method, url, true, user, password);
        this.ctx.invokeCallback(resolveId, []);
    }

    $send(id, body, resolveId, rejectId) {
        const request = this.requests[id];
        request.send(body);
        this.ctx.invokeCallback(resolveId, []);
    }

    $abort(id, resolveId, rejectId) {
        const request = this.requests[id];
        request.abort();
        this.ctx.invokeCallback(resolveId, []);
    }

    $overrideMimeType(id, mimeType, resolveId, rejectId) {
        const request = this.requests[id];
        request.overrideMimeType(mimeType);
        this.ctx.invokeCallback(resolveId, []);
    }
}
